import { AJOUTER_ADMINISTRATION } from './actionTypes'

export const ajouterFormulaireAdministration = (formulaireAdministration) => {
	return ({
		type: AJOUTER_ADMINISTRATION,
		payload: formulaireAdministration
	})
}
